import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const Box = styled.div`
  margin: 2.5rem 0 1.5rem 0;
  color: var(--${props => props.color});
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 2rem;
  font-weight: 500;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2rem;
  width: 4rem;
  height: 4rem;
  border-radius: 10px;
  background: var(--${props => props.color});
  margin-right: 1.5rem;
  flex-shrink: 0;
`

export default class SectionHeader extends Component {
  render() {
    const { color, icon, str } = this.props

    return (
      <Box color={color}>
        <Icon className={icon} color={color} />
        <Text str={str} />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SectionHeader.js